module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navShow),
      expression: "navShow"
    }],
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "main"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_c('li', {
    class: {
      current: _vm.mainNum == 1
    },
    on: {
      "click": function($event) {
        return _vm.changeMainNum(1)
      }
    }
  }, [_c('span', [_vm._v("新歌")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rank"
    }
  }, [_c('li', {
    class: {
      current: _vm.mainNum == 2
    },
    on: {
      "click": function($event) {
        return _vm.changeMainNum(2)
      }
    }
  }, [_c('span', [_vm._v("排行")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/plist"
    }
  }, [_c('li', {
    class: {
      current: _vm.mainNum == 3
    },
    on: {
      "click": function($event) {
        return _vm.changeMainNum(3)
      }
    }
  }, [_c('span', [_vm._v("歌单")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/singer"
    }
  }, [_c('li', {
    class: {
      current: _vm.mainNum == 4
    },
    on: {
      "click": function($event) {
        return _vm.changeMainNum(4)
      }
    }
  }, [_c('span', [_vm._v("歌手")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c560590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 105
// module chunks = 0